import { Dealer } from '@/types/dealer';
import { generateFallbackRating } from './ratingUtils';

/**
 * Format dealers data with spread and rating information
 */
export const formatDealersData = (
  dealers: any[],
  selectedMetal: string = 'ORO',
  spreadByDealer?: Record<string, number>,
  ratingsByDealer?: Record<string, number>
): Dealer[] => {
  console.log('Formatting dealers with ratings:', ratingsByDealer);
  
  if (!dealers || !Array.isArray(dealers)) {
    console.warn('Invalid dealers data provided to formatDealersData');
    return [];
  }
  
  return dealers.map(dealer => {
    // Skip dealers with no ID
    if (!dealer || !dealer.id) {
      console.warn('Invalid dealer entry:', dealer);
      return null;
    }
    
    // CRITICAL FIX: Use the rating directly from the dealer object without transformation
    // This is the biggest change - we keep the original rating value
    const rating = dealer.rating;
    
    console.log(`Dealer ${dealer.name} (${dealer.id}) rating:`, rating);
    
    const formattedDealer: Dealer = {
      id: dealer.id,
      name: dealer.name,
      address: dealer.address,
      city: dealer.city,
      is_verified: dealer.is_verified || false,
      activated: dealer.activated || false,
      latitude: dealer.latitude,
      longitude: dealer.longitude,
      rating: rating,
      buySpread: dealer.buySpread ?? -5, // Use nullish coalescing for default value
      isFavorite: false,
      phone: dealer.phone,
      email: dealer.email,
      postal_code: dealer.postal_code,
      image_url: dealer.image_url,
      opening_hours: dealer.opening_hours
    };
    
    return formattedDealer;
  }).filter(Boolean) as Dealer[]; // Filter out null values
};
